var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export default function listFormat(list) {
    var limit = list.limit, offset = list.offset, count = list.count, results = list.results;
    var mutated = __spreadArrays(results);
    mutated.meta = {
        limit: limit,
        offset: offset,
        count: count
    };
    return mutated;
}
